import React from 'react'


const DashboardStatistics = ({ t,user,provider,trip,revenue }) => {
  return (
    <section className="section-dashboard-cards mb-3">
      <div className="row g-2">
        <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
          <div className="d-card d-card-primary">
            <div className="d-card-header">{t("totalUsers")}</div>
            <div className="d-card-body">
              <div className="d-card-body-1">
                <span>{user?.totalUsers || 0}</span>
                <span>{t("newThisMonth")}: {user?.newThisMonth || 0}</span>
              </div>
              <div className="d-card-body-2 d-none">
                <span>52.0%</span>
                <i className="fas fa-arrow-circle-up"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
          <div className="d-card d-card-dark">
            <div className="d-card-header">{t("totalServiceProviders")}</div>
            <div className="d-card-body">
              <div className="d-card-body-1">
                <span>{provider?.totalProviders || 0}</span>
                <span>{t("newThisMonth")}: {provider?.newThisMonth || 0}</span>
              </div>
              <div className="d-card-body-2 d-none">
                <span>52.0%</span>
                <i className="fas fa-arrow-circle-up"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
          <div className="d-card d-card-primary">
            <div className="d-card-header">{t("totalTrips")}</div>
            <div className="d-card-body">
              <div className="d-card-body-1">
                <span>{trip?.totalTrips || 0}</span>
                <span>{t("newThisMonth")}: {trip?.newThisMonth || 0}</span>
              </div>
              <div className="d-card-body-2 d-none">
                <span>52.0%</span>
                <i className="fas fa-arrow-circle-up"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
          <div className="d-card d-card-dark">
            <div className="d-card-header">{t("totalRevenue")}</div>
            <div className="d-card-body">
              <div className="d-card-body-1">
                <span>{revenue?.totalRevenue || 0}</span>
                <span>{t("thisMonth")}: {revenue?.newThisMonth || 0}</span>
              </div>
              <div className="d-card-body-2 d-none">
                <span>52.0%</span>
                <i className="fas fa-arrow-circle-up"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DashboardStatistics
